import { GLOBAL_TOASTS } from '~coreModules/toasts/js/toasts-constants';

import { NOTIFICATION_DISMISS_DELAY } from '~coreModules/core/js/constants';

export const TOASTS = {
    ...GLOBAL_TOASTS,
    addedToClosetList: {
        delay: NOTIFICATION_DISMISS_DELAY.LONG,
        id: 'added-to-closet-list',
    },
    savedToCloset: {
        delay: NOTIFICATION_DISMISS_DELAY.LONG,
        id: 'saved-to-closet',
    },
};

export default TOASTS;
